import { render } from "./ProductosList.vue?vue&type=template&id=8172adbc&scoped=true"
import script from "./ProductosList.vue?vue&type=script&lang=js"
export * from "./ProductosList.vue?vue&type=script&lang=js"

import "./ProductosList.vue?vue&type=style&index=0&id=8172adbc&lang=css"
import "./ProductosList.vue?vue&type=style&index=1&id=8172adbc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8172adbc"]])

export default __exports__